module.exports = __webpack_public_path__ + "static/media/double_welted_pocket_with_button.01453b4b.svg";